<template>
  <div class="flex space-x-4 p-1 overflow-x-auto h-[80vh] max-w-full">
    <div
      v-for="(list, idx) in lists"
      :key="idx"
      class="w-64 bg-gray-100 rounded p-2 flex flex-col h-full min-w-[30vh]"
    >
      <div class="mb-2">
        <template v-if="list.editing">
          <input
            v-model="list.name"
            ref="el => inputRefs.value[idx] = el"
            @blur="finishEdit(list)"
            @keydown.enter.prevent="finishEdit(list)"
            class="w-full text-lg font-bold bg-transparent border-b border-gray-400 focus:outline-none"
          />
        </template>
        <template v-else>
          <h2
            @click="enableEdit(list, idx)"
            class="text-lg font-bold cursor-pointer select-none"
          >
            {{ list.name }}
          </h2>
        </template>
      </div>

      <section class="mb-6">
        <Draggable
          v-model="list.cards"
          :group="{ name: 'boards', pull: true, put: true }"
          item-key="id"
          class="space-y-2"
        >
          <template #item="{ element, index }">
            <div>
              <template v-if="element.editing">
                <input
                  v-model="element.text"
                  ref="el => {
                    cardInputRefs.value[listIndex] ??= []
                    cardInputRefs.value[listIndex][index] = el
                  }"
                  @blur="finishCardEdit(list, index)"
                  @keydown.enter.prevent="finishCardEdit(list, index)"
                  class="w-full p-2 bg-white border rounded focus:outline-none"
                />
              </template>
              <template v-else>
                <div
                  @click="() => (element.editing = true)"
                  class="p-4 bg-white rounded shadow cursor-text"
                >
                  {{ element.text }}
                </div>
              </template>
            </div>
          </template>
        </Draggable>
      </section>

      <button
        @click="addCard(idx)"
        class="mt-auto py-2 w-full bg-gray-200 text-gray-400 rounded hover:bg-gray-300 transition"
      >
        + Adicionar
      </button>
    </div>
  </div>
</template>

<script setup>
import { nextTick, onMounted, ref, watch } from "vue";
import Draggable from "vuedraggable";

const STORAGE_KEY = "my-board";
const cardInputRefs = ref([]);
const inputRefs = ref([]);
const lists = ref([]);

function addCard(listIndex) {
  const newCard = {
    id: Date.now(),
    text: "",
    editing: true,
  };
  lists.value[listIndex].cards.push(newCard);

  nextTick(() => {
    const cardIdx = lists.value[listIndex].cards.length - 1;
    const input = cardInputRefs.value[listIndex]?.[cardIdx];
    input?.focus();
  });
}

function finishCardEdit(list, cardIndex) {
  const card = list.cards[cardIndex];

  if (!card.text.trim()) {
    // se o texto ficar vazio, remove o próprio card
    list.cards.splice(cardIndex, 1);
  } else {
    // senão, só sai do modo edição
    card.editing = false;
  }
}

// aciona a edição do nome
function enableEdit(list, idx) {
  list.editing = true;
  nextTick(() => inputRefs.value[idx]?.focus());
}

function finishEdit(list) {
  list.editing = false;
}

watch(
  lists,
  (newVal) => localStorage.setItem(STORAGE_KEY, JSON.stringify(newVal)),
  { deep: true }
);

onMounted(() => {
  const saved = localStorage.getItem(STORAGE_KEY);
  lists.value = saved
    ? JSON.parse(saved)
    : [
        { id: 1, name: "TUDO", editing: false, cards: [] },
        { id: 2, name: "CONTROLE", editing: false, cards: [] },
        { id: 3, name: "SEM CONTROLE", editing: false, cards: [] },
        { id: 3, name: "PREOCUPAÇÕES", editing: false, cards: [] },
        { id: 3, name: "OUTRO", editing: false, cards: [] },
      ];
});
</script>
